import React, { useState } from 'react';
import './css/GroupDiscussion.css'; // Dedicated page styles

// Reusing your standalone, modular layout components
import Navbar from './components/Navbar';
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';

// Reusing your global hero and banner background assets
import gdHeroBg from '../images/gd-banner.png';
import feedBgImage from '../images/Banner3.png'; // Background image for the feed section
import DownloadAppForum from './components/DownloadAppForum';

import gd1 from '../images/gd1.jpg';
import gd2 from '../images/gd2.jpg';
import gd3 from '../images/gd3.jpg';


function GroupDiscussion() {
    // State to control the login/register popup modal
    const [showLoginModal, setShowLoginModal] = useState(false);

    // Static array of posts with different background themes and border variants
    const postsData = [
        {
            id: 1,
            title: "Cracking Technical Group Discussions: Key Strategies",
            description: "Mastering a technical group discussion requires a balance of active listening, structured reasoning, and clear articulation. Discover how to steer complex technical topics toward constructive consensus.",
            image: gd1,
            postedBy: "Dr. Arindam Roy",
            postingDate: "August 6, 2026",
            commentCount: 6,
            bgColor: "rgba(255, 255, 255, 0.92)",
            borderColor: "#165682"
        },
        {
            id: 2,
            title: "The Role of Critical Thinking in Modern Assessments",
            description: "Traditional rote learning is rapidly being replaced by evaluative analytical frameworks. Explore why modern competitive examinations and institutional interviews prioritize deep cognitive synthesis.",
            image: gd2,
            postedBy: "Prof. Sneha Sen",
            postingDate: "August 4, 2026",
            commentCount: 3,
            bgColor: "rgba(255, 255, 255, 0.92)",
            borderColor: "#3F9A96"
        },
        {
            id: 3,
            title: "Peer Collaboration and Academic Growth Systems",
            description: "Collective intelligence accelerates individual problem-solving skills. Learn how structured peer forums and shared query resolutions drastically amplify long-term concept retention rates.",
            image: gd3,
            postedBy: "Vikramaditya Bose",
            postingDate: "August 1, 2026",
            commentCount: 8,
            bgColor: "rgba(255, 255, 255, 0.92)",
            borderColor: "#D59B0F"
        }
    ];

    const handleCommentClick = (e) => {
        e.preventDefault();
        setShowLoginModal(true);
    };

    return (
        <div className="gd-page-wrapper">

            {/* 1. Header Hero Section with integrated clean Navbar */}
            <section
                className="gd-hero-section"
                style={{ backgroundImage: `url(${gdHeroBg})` }}
            >
                <Navbar />
            </section>

            {/* 2. Facebook-style Social Feed Section with Background Image & Scrollable Container */}
            <section
                className="gd-feed-section py-5"
                style={{
                    backgroundImage: `url(${feedBgImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'repeat'
                }}
            >
                <div className="container">
                    <div className="row justify-content-center text-center mb-4">
                        <div className="col-lg-8">
                            <span className="ufc-grid-mini-tag">SCHOLARS' DISCUSSIONS</span>
                            <h2 className="ufc-grid-heading" style={{ color: '#207AB4' }}>
                                Community Feed & Insights
                            </h2>
                            <div className="ufc-zigzag-border mx-auto mt-2"></div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            {/* Scrollable Wrapper with Max Height */}
                            <div
                                className="gd-scrollable-feed-container pe-2"
                                style={{
                                    maxHeight: '800px',
                                    overflowY: 'auto',
                                    scrollbarWidth: 'thin'
                                }}
                            >
                                {postsData.map((post) => (
                                    <div
                                        key={post.id}
                                        className="gd-post-card mb-4 p-4 shadow-sm"
                                        style={{
                                            backgroundColor: post.bgColor,
                                            border: `2px solid ${post.borderColor}`,
                                            borderRadius: '16px',
                                            backdropFilter: 'blur(10px)',
                                            WebkitBackdropFilter: 'blur(10px)'
                                        }}
                                    >
                                        {/* Author & Date Info */}
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="gd-author-info">
                                                <span className="fw-bold text-dark" style={{ fontSize: '15px' }}>{post.postedBy}</span>
                                            </div>
                                            <div className="gd-post-date text-muted" style={{ fontSize: '13px' }}>
                                                {post.postingDate}
                                            </div>
                                        </div>

                                        {/* Post Heading */}
                                        <h3 className="gd-post-heading h5 fw-bold mb-2" style={{ color: '#207AB4' }}>
                                            {post.title}
                                        </h3>

                                        {/* Post Description */}
                                        <p className="gd-post-desc text-secondary mb-3" style={{ fontSize: '14.5px', lineHeight: '1.5' }}>
                                            {post.description}
                                        </p>

                                        {/* Post Image Showcase */}
                                        {post.image && (
                                            <div className="gd-post-img-wrapper mb-3 overflow-hidden rounded-3">
                                                <img src={post.image} alt={post.title} className="img-fluid w-100 rounded-3" style={{ maxHeight: '280px', objectFit: 'cover' }} />
                                            </div>
                                        )}

                                        {/* Interaction Footer: Comment Box Trigger */}
                                        <div className="gd-post-footer pt-3 border-top d-flex justify-content-between align-items-center">
                                            <div
                                                className="gd-comment-trigger-box d-flex align-items-center flex-grow-1 me-3 p-2 px-3 rounded-pill bg-white border cursor-pointer"
                                                onClick={handleCommentClick}
                                                style={{ cursor: 'pointer', borderColor: post.borderColor }}
                                            >
                                                <span className="text-muted" style={{ fontSize: '13.5px' }}>Write a comment or share your thoughts...</span>
                                            </div>
                                            <div className="gd-comment-counter fw-bold text-nowrap" style={{ fontSize: '13.5px', color: '#165682' }}>
                                                💬 {post.commentCount} Comments
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Login / Register Popup Modal */}
           
            {showLoginModal && (
                <div
                    className="gd-modal-backdrop position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                    style={{
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        zIndex: 9999
                    }}
                >
                    <div
                        className="gd-modal-content bg-white p-4 rounded-4 shadow text-center position-relative mx-3"
                        style={{
                            maxWidth: '400px',
                            width: '100%'
                        }}
                    >
                        <h4
                            className="fw-bold mb-3"
                            style={{ color: '#207AB4' }}
                        >
                            Authentication Required
                        </h4>

                        <p
                            className="text-secondary mb-4"
                            style={{ fontSize: '14px' }}
                        >
                            You need to login or register first to comment or make a post in the scholars' discussion feed.
                        </p>

                        <div className="d-flex gap-2 justify-content-center">

                            {/* Login */}
                            <button
                                onClick={() =>
                                    window.open(
                                        'https://forum.crestest.com/login',
                                        '_blank',
                                        'noopener,noreferrer'
                                    )
                                }
                                className="btn text-white px-4 py-2 rounded-pill fw-bold border-0"
                                style={{
                                    backgroundColor: '#207AB4',
                                    fontSize: '14px'
                                }}
                            >
                                Login
                            </button>

                            {/* Register */}
                            <button
                                onClick={() =>
                                    window.open(
                                        'https://forum.crestest.com/register',
                                        '_blank',
                                        'noopener,noreferrer'
                                    )
                                }
                                className="btn px-4 py-2 rounded-pill fw-bold border"
                                style={{
                                    backgroundColor: '#57BDB9',
                                    color: '#ffffff',
                                    borderColor: '#3F9A96',
                                    fontSize: '14px'
                                }}
                            >
                                Register
                            </button>

                        </div>

                        {/* Close */}
                        <button
                            onClick={() => setShowLoginModal(false)}
                            className="position-absolute top-0 end-0 m-3 border-0 bg-transparent text-muted fw-bold fs-5"
                            style={{ cursor: 'pointer' }}
                        >
                            &times;
                        </button>
                    </div>
                </div>
            )}
         


            {/* Download App Section */}
            <DownloadAppForum />

            {/* 3. Reusable Global Bottom Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default GroupDiscussion;

